import { useEcoClient, useEcoMutation } from 'hooks';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { useQuizStore } from './useQuizStore';
import { quizLoaded, quizUser } from "../states/quizState";
import { quizType, RegistrationType } from 'components';

export const useGetDataQuiz = (quizName: string, id?: string, userId?: string): { [key: string]: any } => {
    const [data, setData] = useState<{ [key: string]: any }>();
    const ecoClient = useEcoClient();
    const [quizload, setQuizLoaded] = useRecoilState(quizLoaded)
    const {setQuizInfo, setResponseList, setFilledResponses, setStepList, getLastResponse } = useQuizStore()
    const navigate = useNavigate()
    const setUser = useSetRecoilState(quizUser)

    useEffect(() => {
        if (!quizload.name || (quizload.name != quizName)) {
            if(id && userId) {
                getResponseQuizById.mutate( ({id, userId}), {
                    onSuccess: (res: any) => {
                        const intanceData = res.data as quizDataType;
                        intanceData.responses && setResponseList(intanceData.responses.join(';'))
                        intanceData.responses && setFilledResponses(intanceData.responses.join(';'))
                        intanceData.questions && setStepList(intanceData.questions.join(';'))
                        setUser({
                            ...intanceData.user, 
                            userId: parseInt(userId)})
                        setQuizInfo({
                            id: parseInt(id), 
                            name: quizName, 
                            isFormInstance: true, 
                            nodePrefix: intanceData.ke || ""});
                        const xstateData = mapXstateFormat(JSON.parse(intanceData.extData || ""))
                        setData(xstateData)
                        setQuizLoaded({name: quizName, data: xstateData, id: intanceData.templateId })
                        navigate(`/quiz/${quizName}/${getLastResponse()}`)
                    },
                    onError: (e) => {
                        console.log(e)
                    }
                })
            } else {
                getQUiz.mutate(({name: quizName, project :'medical-device'}), {
                    onSuccess: (res: any) => {
                        const template = res.data
                        const xstateData = mapXstateFormat(JSON.parse(template.extData))
                        setData(xstateData)
                        setQuizInfo({id: template.extId as number, name: quizName, isFormInstance: false, nodePrefix: template.ke});
                        setQuizLoaded({name: quizName, data: xstateData, id: template.extId })
                    },
                    onError: (e) => {
                        console.log(e)
                    }
                })
            } 
        } else {
            setData(quizload.data)
        }
    }, [quizName])


    const getQUiz = useEcoMutation(async (params: templateParams)  => {
        return ecoClient.get({
            path: `quiz.get`,
            params: {...params}
        });
    })

    const getResponseQuizById = useEcoMutation(async (params: templateByIdParams)  => {
        return ecoClient.get({
            path: `quiz.getById`,
            params: {...params}
        });
    })
    
    return {
        data
    }
}

type templateParams = {
    project: string
    name: string
}

type templateByIdParams = {
    id: string
    userId: string
}

type quizDataType = quizType & {
    user: RegistrationType & { userId?: number }
}

const mapXstateFormat = (dataFlow: Array<Record<string, any>>) => {
    let xstates = {}
    getAllNodes(dataFlow).map((item: Record<string, any>) => {
        return {
            [item?.data?.nodeName || item?.data?.label]: {
                on: { ...getTransitionByNodeId(item?.id, dataFlow)},
                meta: {
                    title: item?.data?.label,
                    type: item?.type ? item.type: 'inside',
                    nodeName: item.data?.nodeName || item?.data?.label,
                    customNode: item.data?.customNode || false,
                    ...getLabelTransitionByNodeId(item?.id, dataFlow)
                }
            }
        }
    }).forEach(state => {
        xstates = {...xstates, ...state}
    });
    return xstates
}

const getAllTransitions = (dataFlow: Array<Record<string, any>>) => {
    return dataFlow.filter((item) => item?.data?.nodeType == 'transition')
}

const getAllNodes = (dataFlow: Array<Record<string, any>>) => {
    return dataFlow.filter((item) => item?.data?.nodeType == 'box')
}

const getTransitionByNodeId = (nodeId: string, dataFlow: Array<Record<string, any>>) => {
    let transitions = {}
    getAllTransitions(dataFlow).filter((item) => `${item?.source}` === nodeId).map(trans => {
        return {
            [trans?.data?.nodeName || trans?.label] : {
                target: getNodeNameById(trans?.target, dataFlow)
            }
        }
    }).forEach(trans => {
        transitions = {...transitions, ...trans }
    });
    return transitions
}

const getNodeNameById = (nodeId: string, dataFlow: Array<Record<string, any>>) => {
    const node = dataFlow.find(item => item.id == nodeId)
    return node?.data?.nodeName || node?.data?.label
}

const getLabelTransitionByNodeId = (nodeId: string, dataFlow: Array<Record<string, any>>) => {
    let metaData = {}
    getAllTransitions(dataFlow).filter((item) => `${item?.source}` === nodeId).map(trans => {
        return {
            [trans?.data?.nodeName || trans?.label] : trans?.label
        }
    }).forEach((meta) => {
        metaData = {...metaData, ...meta }
    })
    return metaData
}